import {
  Button,
  Card,
  CardContent,
  CardGrid,
  CardGridColumn,
  CardHeaderRow,
  Heading,
  mediaQueries,
  style
} from '@do/walrus';
import React, { ReactElement } from 'react';
import styled, { css } from 'styled-components';
import timeoutBackground from '../assets/backgrounds/TimeoutBackground.svg';
import { HEADER_HEIGHT } from '../constants';
import copy from '../copy';
import useDocumentTitle from '../hooks/use-document-title';
import { SectionWithFullScreenBackground } from './Common';
import Header from './Header';
import Text from './Text';

interface CardTypes {
  title: string;
  description: string;
  button: string;
  image: string;
  link: string;
}

const HeroContainer = styled(SectionWithFullScreenBackground)`
  padding-top: ${style.vars.space['10']};
  padding-bottom: ${style.vars.space['10']};
  margin-top: ${HEADER_HEIGHT}px;

  &:before {
    background-image: url(${timeoutBackground});
  }
`;

const Headings = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 740px;
  gap: ${style.vars.space['3']};
  text-align: center;
  margin: 0 auto;
`;

const CardContainer = styled.div`
  padding: ${style.vars.space['10']} 0;
  max-width: 1200px;
  margin: 0 auto;

  ${mediaQueries.largeMax} {
    padding: ${style.vars.space['8']};

    ${CardGrid} {
      grid-template-columns: 1fr;
    }

    ${CardGridColumn} {
      align-items: center;
    }
  }
`;

const StyledCard = styled(Card)`
  height: 100%;
  width: 378px;
`;

const StyledCardContent = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;

  p {
    color: ${style.colors.black};
  }
`;

const CardImage = styled.div<{ image: string }>`
  width: 100%;
  height: 160px;
  background-repeat: no-repeat;
  background-size: contain;
  ${(props) =>
    css`
      background-image: url(${props.image});
    `};
`;

const SessionExpired: React.FC = (): ReactElement => {
  useDocumentTitle(copy.session.page_title);

  return (
    <>
      <Header showSignup={false} />
      {/* <Wrap> */}
      <HeroContainer>
        <Headings>
          <Heading level="h1" color="white">
            Your session has timed out.
          </Heading>
          <Heading level="h3" color="white" weight="base">
            If you still have work to do, you can access your Billing and
            payment information through your Paperspace team.
          </Heading>
          <Text inverted>If you're finished, you can close this tab.</Text>
        </Headings>
      </HeroContainer>
      <CardContainer>
        <CardGrid>
          {copy.session.cards.map((card: CardTypes) => {
            return (
              <CardGridColumn>
                <StyledCard>
                  <CardImage image={card.image} />
                  <CardHeaderRow>
                    <Heading level="h4">{card.title}</Heading>
                  </CardHeaderRow>
                  <StyledCardContent>
                    <Text>{card.description}</Text>
                    <Button url={card.link} variation="secondary" fullWidth>
                      {card.button}
                    </Button>
                  </StyledCardContent>
                </StyledCard>
              </CardGridColumn>
            );
          })}
        </CardGrid>
      </CardContainer>
    </>
  );
};

export default SessionExpired;
